<div class="ir-login-image-wrapper">
  <img class="ir-login-image" src="../../assets/img/logo.svg" alt="Logo" width="150" />
</div>
<div class="container">
  <div class="row justify-content-center">
    <div class="card login-card-wrapper">
      <div class="card-header">
        <h3>Reset Password</h3>
      </div>
      <div class="card-body">
        <form [formGroup]="passwordForm">
          <div class="form-group">
            <label for="newPassword">New Password</label>
            <input type="password" id="newPassword" placeholder="New Password" formControlName="password" required class="login-username" />
            @if (passwordControl.invalid) {
              <small>10 characters with a upper, lower, number and special character</small>
            }
            <div class="error fw-bold">
              {{ getPasswordErr() }}
            </div>
          </div>

          <div class="form-group">
            <label for="password">Repeat Password</label>
            <div class="input-group password-wrapper">
              <input
                class="form-control login-username"
                id="password"
                type="password"
                placeholder="Repeat Password"
                formControlName="confirmPassword"
                required
                (focus)="onFocus()" />
            </div>
            <div class="error fw-bold">
              {{ getConfirmPwdErr() }}
            </div>
          </div>

          <div class="form-actions">
            <button class="form-control form-control-lg" [disabled]="passwordForm.invalid" type="button" (click)="reset()">
              Reset Password
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
